export var PriorityScoreUpdateType;
(function (PriorityScoreUpdateType) {
    PriorityScoreUpdateType[PriorityScoreUpdateType["SET"] = 1] = "SET";
    PriorityScoreUpdateType[PriorityScoreUpdateType["INCREASE"] = 2] = "INCREASE";
    PriorityScoreUpdateType[PriorityScoreUpdateType["DECREASE"] = 3] = "DECREASE";
})(PriorityScoreUpdateType || (PriorityScoreUpdateType = {}));
//# sourceMappingURL=index.js.map